import { Appointment, AppointmentStatus } from "@myapp/contract";

const STATUS_LABELS: Record<AppointmentStatus, string> = {
  PLANNED: "Geplant",
  FOLLOW_UP: "Folgetermin geplant",
  COMPLETED: "Abgeschlossen",
  COMPLETED_WITH_FOLLOW_UP: "Folgetermin erforderlich",
  EXPIRED: "Abgelaufen",
};

const IN_PROGRESS_LABEL = "In Bearbeitung";
const IN_PROGRESS_COLOR = "#ED9E42";

export const isAppointmentInProgress = (
  a: Pick<Appointment, 'status' | 'actualStart' | 'actualEnd'>,
): boolean => (a.status === 'PLANNED'|| a.status == 'FOLLOW_UP') && !!a.actualStart && !a.actualEnd;

export const getAppointmentStatusLabel = (
  status: AppointmentStatus,
  appointment?: Pick<Appointment, 'status' | 'actualStart' | 'actualEnd'>,
): string => {
  if (appointment && isAppointmentInProgress(appointment)) return IN_PROGRESS_LABEL;
  return STATUS_LABELS[status];
};

const STATUS_COLORS: Record<AppointmentStatus, string> = {
  PLANNED: "#2EB5D9",
  FOLLOW_UP: "#2EB5D9",
  COMPLETED: "#3BC67D",
  COMPLETED_WITH_FOLLOW_UP: "#ED9E42",
  EXPIRED: "#9CA3AF",
};

export const getAppointmentStatusColor = (
  status: AppointmentStatus,
  appointment?: Pick<Appointment, 'status' | 'actualStart' | 'actualEnd'>,
): string => {
  if (appointment && isAppointmentInProgress(appointment)) return IN_PROGRESS_COLOR;
  return STATUS_COLORS[status];
};
